import React from "react";
import { useField, FieldConfig } from "formik";
import FormGroup from "react-bootstrap/FormGroup";
import FormLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import cn from "classnames";

interface FormikFieldGroupProps {
    type: string;
    className?: string;
    label?: string;
    placeholder?: string;
    maxLength?: number;
    disabled?: boolean;
    readOnly?: boolean;
    checked?: boolean;
    fragile?: boolean; // when true, an invalid field will display error even when touched is false
}

const FormikFieldGroup: React.FunctionComponent<FormikFieldGroupProps & FieldConfig> = ({
    type,
    className,
    label,
    fragile,
    ...props
}) => {
    const [field, meta] = useField(props);

    const isInvalid: boolean = meta.error && (fragile || meta.touched);

    return (
        <FormGroup className={cn(className)}>
            <FormLabel htmlFor={props.name}>{label}</FormLabel>
            <input
                {...field}
                {...props}
                type={type}
                id={props.name}
                className={cn("form-control", {
                    "is-invalid": isInvalid,
                })}
            />
            {isInvalid && (
                <FormControl.Feedback data-testid={`errors-${props.name}`} type="invalid">
                    {meta.error || ""}
                </FormControl.Feedback>
            )}
        </FormGroup>
    );
};

export default FormikFieldGroup;
